import type {
  CustomCollectionsStepAssets,
  CustomCollectionsFieldConfig,
} from "@dreambigger/shared/src/types";
import isCustomFieldSection from "@dreambigger/shared/src/utils/isCustomFieldSection";

/** Extract the field configs from a custom step's customFields list, dropping
 *  any section markers. Use at call sites that iterate customFields for
 *  field-only behavior (validation, form rendering by key, incomplete
 *  detection, etc.). */
export default function extractCustomFields(
  entries: CustomCollectionsStepAssets["customFields"]
): CustomCollectionsFieldConfig[] {
  if (!entries) return [];
  return entries.filter(
    (e): e is CustomCollectionsFieldConfig => !isCustomFieldSection(e)
  );
}
